import leadApi from '@src/features/leads/services/lead-api';
import { LEAD_RANK, type TLead } from '@src/shared/types/lead';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import {
  EditableDropdownCell,
  EditableDropdownCellEditMode,
  EditableDropdownCellItem,
  EditableDropdownCellViewMode,
} from '@src/shared/components/editable-dropdown-cell';
import { rankColorMap } from '@src/design-system/molecules/ticlick-table';
import { cn } from '@src/design-system/helpers';

export function LeadRankCell({
  leadId,
  rank,
}: {
  leadId: number;
  rank?: TLead['rank'];
}) {
  const { mutate: updateLead, variables } = leadApi.useUpdate();
  const optimisticRank = variables?.rank ?? rank ?? '—';

  return (
    <EditableDropdownCell>
      <EditableDropdownCellViewMode>
        <p
          className={cn(
            rankColorMap[optimisticRank],
            'py-1 px-2.5 rounded-md text-sm font-medium'
          )}
        >
          {formatTextForDisplay(optimisticRank)}
        </p>
      </EditableDropdownCellViewMode>
      <EditableDropdownCellEditMode>
        {Object.values(LEAD_RANK).map((item) => (
          <EditableDropdownCellItem
            key={item}
            isSelected={String(item) === String(optimisticRank)}
            onClick={() => updateLead({ id: leadId, rank: item })}
          >
            {formatTextForDisplay(item)}
          </EditableDropdownCellItem>
        ))}
      </EditableDropdownCellEditMode>
    </EditableDropdownCell>
  );
}
